import styled from 'styled-components';

import { Button } from '@nw/omega-design-system';

export const RegisterButtonStyled = styled(Button)`
  width: 100%;
  font-family: 'Inter', sans-serif;
`;
